export default "__VITE_ASSET__CXpwZH4a__"